import { omit } from "lodash";
import { JSX } from "react";

type ButtonProps = {
	secondary?: boolean;
	danger?: boolean;
	success?: boolean;
	outline?: boolean;
	link?: boolean;
	linkWithoutBackgound?: boolean;
	underline_link?: boolean;
	endIcon?: JSX.Element;
	startIcon?: JSX.Element;
	className?: string;
	isSelected?: boolean;
	[prop: string]: any;
};

const Button = ({
	primary,
	secondary,
	danger,
	success,
	outline,
	link,
	linkWithoutBackgound,
	underline_link,
	endIcon,
	startIcon,
	className,
	isSelected,
	...props
}: ButtonProps) => {
	if (outline)
		return (
			<button
				className={`outline-button
                ${secondary ? " outline-button--secondary" : ""}
                ${danger ? " outline-button--danger" : ""}
                ${
									startIcon
										? " outline-button-with-icon outline-button-with-icon--start"
										: ""
								}
                ${
									endIcon
										? " outline-button-with-icon outline-button-with-icon--end"
										: ""
								}
                ${className ? ` ${className}` : ""}
                ${isSelected ? " outline-button--selected" : ""}`}
				{...omit(props, ["primary"])}
			>
				{startIcon}
				{props.children}
				{endIcon}
			</button>
		);

	if (link || underline_link || linkWithoutBackgound)
		return (
			<button
				className={`button-link${
					secondary ? " button-link--secondary" : ""
				}${danger ? " button-link--danger" : ""}${
					success ? " button-link--success" : ""
				}${
					startIcon ? " button-link-with-icon button-link-with-icon--start" : ""
				}
          ${endIcon ? " button-link-with-icon button-link-with-icon--end" : ""}
          ${className ? ` ${className}` : ""}
          ${underline_link ? ` button-link--underline` : ""} ${
						linkWithoutBackgound && "button-link--without-background"
					}`}
				{...props}
			>
				{startIcon ? startIcon : null}
				{props.children}
				{endIcon ? endIcon : null}
			</button>
		);
	return (
		<button
			className={`button${secondary ? " button--secondary" : ""}${
				danger ? " button--danger" : ""
			}${startIcon ? " button-with-icon button-with-icon--start" : ""}${
				className ? ` ${className}` : ""
			}`}
			{...props}
		>
			{startIcon ? startIcon : null}
			{props.children}
			{endIcon ? endIcon : null}
		</button>
	);
};

export { Button };
